import standardAPI from '@/api/standard_items';

const state = {
  partnership: [],
  partnership_status: '',
  partnership_MetaData: {},
  partnership_page: 1,
  partnership_perPage: 10,
};

const responseUrl = '/partnerships';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_partnerships ({ commit }, getOptions) {
    commit('PARTNERSHIP_BID_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PARTNERSHIP_BID_SUCCESS', response);
            commit('PARTNERSHIP_BID_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PARTNERSHIP_BID_READY');
            reject(response);
          } else {
            commit('PARTNERSHIP_BID_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_partnership ({ commit, dispatch }, itemData) {
    commit('PARTNERSHIP_BID_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('PARTNERSHIP_BID_READY');
          resolve(response);
        } else {
          commit('PARTNERSHIP_BID_READY');
          reject(response);
        }
      });
    });
  },
  edit_partnership ({ commit, dispatch }, itemData) {
    commit('PARTNERSHIP_BID_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('PARTNERSHIP_BID_READY');
          resolve(response);
        } else {
          commit('PARTNERSHIP_BID_READY');
          reject(response);
        }
      });
    });
  },
  remove_partnership ({ commit, dispatch }, itemData) {
    commit('PARTNERSHIP_BID_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('PARTNERSHIP_BID_READY');
          resolve(response);
        } else {
          commit('PARTNERSHIP_BID_READY');
          reject(response);
        }
      });
    });
  },
  reorder_partnership ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.partnership_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.partnership_perPage = max;
  },
  PARTNERSHIP_BID_READY: (state) => {
    state.partnership_status = 'ready';
  },
  PARTNERSHIP_BID_REQUEST: (state) => {
    state.partnership_status = 'loading';
  },
  PARTNERSHIP_BID_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.partnership_MetaData.meta = response.meta;
      state.partnership_MetaData.links = response.links;
    }
    state.partnership = response.data;
    state.partnership_status = 'success';
  },
  PARTNERSHIP_BID_ERROR: (state) => {
    state.partnership_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
